// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__nAEw6","container":"styles_container__XOsb_","title":"styles_title__2bjQW","wrapper":"styles_wrapper__34zlf","answer":"styles_answer__3lkFb"};